import Cookies from 'universal-cookie';

let persistence = true;

function setPersistence(enabled) {
  persistence = enabled;
}

function getPersistace() {
  const cookies = new Cookies();
  const rlog = cookies.get('rlog');

  return !!rlog ? true : persistence;
}

export default {
  setPersistence,
  storage: () => {
    return typeof window !== 'undefined' ? (getPersistace() ? window.localStorage : window.sessionStorage) : {};
  },
};
